export const AIR_MOBILE_APP_IOS_URL = 'https://apps.apple.com/us/app/air-unlock-creative-flow/id6755408051';

const AIR_WEBSITE_URL = process.env.NEXT_PUBLIC_AIR_WEBSITE_URL || 'https://air.inc';

// Same-domain Universal Links never fire on app.air.inc, so the handoff lives on air.inc instead
// (a separate domain the mobile app also claims) — see PER-144.
export const buildMobileHandoffUrl = ({ workspaceId, returnTo }: { workspaceId: string; returnTo: string }): string => {
  const url = new URL('/mobile/open', AIR_WEBSITE_URL);

  url.searchParams.set('workspaceId', workspaceId);
  url.searchParams.set('returnTo', returnTo);

  return url.toString();
};
